import React, { useEffect } from 'react';
import { styled } from 'styled-components';
import { bp, size } from '../../../styles/breakPoints.tsx';
import { ChevronRight } from '@styled-icons/material';
import { Color, Image } from '../../types.ts';

interface Button {
  icon: Image;
  text: string;
  link: string;
  visibility: 'all' | 'desktop' | 'mobile';
}
interface LinkCardsProps {
  fieldValues: {
    background_color_primary: Color;
    background_color_secondary: Color;
    buttons: Button[];
  };
}

const StyledLinkButtons = styled.div<{ $primaryColor: Color, $secondaryColor: Color }>`
  background: ${(props) => `linear-gradient(180deg, ${props.$primaryColor.css} 25%, ${props.$secondaryColor.css} 100%)`};  // props.$backgroundColor.css ?? 'green'}; ;
  --mask:
    radial-gradient(33.63px at 50% 47.5px,#000 99%,#0000 101%) calc(50% - 50px) 0/100px 100%,
    radial-gradient(33.63px at 50% -22.5px,#0000 99%,#000 101%) 50% 25px/100px 100% repeat-x;
  -webkit-mask: var(--mask);
          mask: var(--mask);

  padding: 48px 16px;

  .buttons {
    padding: 24px 0;
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
    justify-content: center;

    @media ${bp.md} {
      padding: 32px 16px;
    }

    .link-button {
      text-decoration: none;
      color: #000;
      font-size: 18px;
      font-weight: 400;
      border-radius: 8px;
      border: 1.5px solid #C0A3ED;
      background: #fff;

      box-shadow: 0px 1px 24px 8px rgba(20, 20, 20, 0.08);

      display: flex;
      padding: 16px;
      align-items: center;
      gap: 12px;
      width: 100%;
      justify-content: space-between;
      text-align: center;

      @media ${bp.md} {
        width: auto;
        font-size: 20px;
      }
    }
  }
`;

function LinkButtons(props: LinkCardsProps) {
  const { background_color_primary, background_color_secondary, buttons } = props.fieldValues;

  const [filteredButtons, setFilteredButtons] = React.useState<Button[]>(buttons);

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth <= size.lg
      const filtered = buttons.filter((button) => {
        if (!button.visibility) {
          return true; // If no visibility is set, show the button
        }
        if (isMobile) {
          return button.visibility === 'all' || button.visibility === 'mobile';
        } else {
          return button.visibility === 'all' || button.visibility === 'desktop';
        }
      });
      setFilteredButtons(filtered);
    };

    handleResize(); // Call once to set the initial state
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <StyledLinkButtons $primaryColor={background_color_primary} $secondaryColor={background_color_secondary}>
      <div className='buttons'>
        {filteredButtons.map((button, index) => (
          <a href={button.link} key={index} className='link-button'>
            <img src={button.icon.src} alt={button.icon.alt} width={40} height={40} />
            <span dangerouslySetInnerHTML={{ __html: button.text }}></span>
            <ChevronRight size={24} />
          </a>
        ))}
      </div>
    </StyledLinkButtons>
  );
}

export default LinkButtons;
